<template>
  <div v-loading="loading" class="event-format-tab">
    <div class="row mb-2" v-if="validationErrors">
      <div class="col">
        <el-alert type="error">
          {{ validationErrors }}
        </el-alert>
      </div>
    </div>

    <!-- Seating Style Section -->
    <div class="row">
      <div class="col-12">
        <div class="form-section mr-1">
          <base-input
            label="Seating Style"
            >
            <SeatingStyle 
              :modelValue="form.seating_style"
              @update:modelValue="onSeatingStyleChange"
              label=""
              :error="fieldErrors.seating_style"
            />
          </base-input>
        </div>
      </div>
    </div>

    <!-- Breakout Room Section -->
    <div class="row mt-4">
      <div class="col-lg-6">
            <base-input
            label="Breakout Room Required"
            >
                <el-select v-model="form.break_rooms_required" placeholder="Breakout Room Required" :clearable="true">
                    <el-option value="">
                    </el-option>
                    <el-option
                    v-for="(option, index) in breakout_room_options"
                    :key="index"
                    :label="option.label"
                    :value="option.value">
                    </el-option>
                </el-select>
            </base-input>
            <base-input
            label="Green rooms required?"
            >
                <el-select v-model="form.green_rooms_required" placeholder="Green rooms required?" :clearable="true">
                    <el-option value="">
                    </el-option>
                    <el-option
                    v-for="(option, index) in green_room_options"
                    :key="index"
                    :label="option.label"
                    :value="option.value">
                    </el-option>
                </el-select>
            </base-input>
        </div>
        <div class="col-6">
          <div class="form-section">
            <base-input
            label="AV Requirements"
            >
              <textarea
                class="form-control"
                v-model="form.av_requirements"
                :rows="4"
              ></textarea>
            </base-input>
          </div>
        </div>
    </div>

    <!-- Save Button -->
    <div class="row mt-3">
      <div class="col-12 text-right">
        <base-button 
          type="primary" 
          @click="saveEventFormat"
          :loading="loading"
        >
          Save & Next
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Option,
  Notification
} from "element-ui";
import { mapState } from "vuex";
import LeadEventService from '@/services/lead-event.service';
import SeatingStyle from '@/components/Custom/SeatingStyle.vue';
import leadEventFormMixin from '@/helpers/leadEventFormMixin';

export default {
  name: 'EventFormat',
  mixins: [leadEventFormMixin],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Notification.name]: Notification,
    SeatingStyle,
  },
  props: {
    leadEvent: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      loading: false,
      validationErrors: '',
      fieldErrors: {},
      form: {
        step: 2,
        direct_update: true,
        seating_style: null,
        green_rooms_required: null,
        break_rooms_required: null,
        av_requirements: null,
      },
      breakout_room_options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
      green_room_options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    };
  },
  computed: {
    ...mapState("country/", {
      country: (state) => state.country || 'AU',
    }),
  },
  methods: {
    async saveEventFormat() {
      
      this.loading = true;
      try {
        var data  = {...this.form};
        if (this.form.seating_style) {
          data.seating_style = [this.form.seating_style];
        }
        await LeadEventService.updateCorporateLeadEvent(this.leadEvent.id, data);

        // Emit success event to parent
        this.$emit('onSave', {
          message: 'Event format saved successfully',
        });
        
        // Show success message
        Notification.success({
					title: 'Success',
					message: 'Event format saved successfully!',
					type: 'success',
				});
        
      } catch (error) {
        console.error('Error saving event format:', error);
        // Show error message
        Notification.error({
          title: 'Error',
          message: 'Failed to save event format. Please check your inputs and try again.',
          type: 'error',
        });
      } finally {
        this.loading = false;
      }
    },
    
    updateFormFromLeadEvent(leadEvent) {
      // Update form fields from leadEvent data, preserving existing values when new data is missing
      const safeUpdate = (currentValue, newValue) => {
        return (newValue !== null && newValue !== undefined && newValue !== '') ? newValue : currentValue;
      };

      // Handle green room value conversion
      let greenRoomRequired = this.safeBooleanUpdate(leadEvent.green_rooms_required);

      let breakRoomValue = this.safeBooleanUpdate(leadEvent.break_rooms_required);

      let seatingStyleValue = leadEvent.seating_style;
      if (Array.isArray(seatingStyleValue) && seatingStyleValue.length > 0) {
        seatingStyleValue = seatingStyleValue[0];
      }

      this.form.seating_style = safeUpdate(this.form.seating_style, seatingStyleValue);
      this.form.green_rooms_required = safeUpdate(this.form.green_rooms_required, greenRoomRequired);
      this.form.break_rooms_required = safeUpdate(this.form.break_rooms_required, breakRoomValue);
      this.form.av_requirements = safeUpdate(this.form.av_requirements, leadEvent.av_requirements);

      console.log('Event format form updated with leadEvent data:', this.form);
    },
    onSeatingStyleChange(value) {
      this.form.seating_style = value;
      console.log('Seating style changed to:', value);
    }
  },
  mounted() {
    // Initialize form with leadEvent data when component is mounted
    if (this.leadEvent) {
      this.updateFormFromLeadEvent(this.leadEvent);
    }
  },
  watch: {
    leadEvent: {
      handler(newLeadEvent) {
        if (newLeadEvent) {
          this.updateFormFromLeadEvent(newLeadEvent);
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>